import React, { Component } from "react";
import { connect } from "react-redux";

import { createOrderStatus } from "actions/orderStatus";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/OrderStatus/Form";

class OrderStatusCreate extends Component {
  handleFormSubmit = data => {
    this.createOrderStatus(data);
  };

  createOrderStatus(data) {
    const { toggleNotification, toggleFullPageSpinner, createOrderStatus, history } = this.props;
    toggleFullPageSpinner(true);
    createOrderStatus(data)
      .then(() => {
        toggleNotification(true, { message: "Created OrderStatus Success", infoClassName: "is-success" });
        history.push(`/order-status`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} />;
  }
}

export default connect(
  null,
  {
    createOrderStatus,
    toggleFullPageSpinner,
    toggleNotification
  }
)(OrderStatusCreate);



// WEBPACK FOOTER //
// ./src/pages/OrderStatus/Create/index.js